import React from 'react';

const FileManagerIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            width="32"
            height="32"
            className=""
        >
            <g data-name="55 - folder opened">
                <path
                    d="M7.9 13h18.72v-2a3 3 0 0 0-3.06-3h-6.48a1.09 1.09 0 0 1-.67-.23l-4-3.12a3.09 3.09 0 0 0-1.9-.65H5.06A3 3 0 0 0 2 7v17.65l3-9.54A3.05 3.05 0 0 1 7.9 13z"
                    fill="#6a6a6a"
                />
                <path
                    d="M29.82 15H7.9a1 1 0 0 0-1 .7L3.23 27.39l.27.18.27.14a2.46 2.46 0 0 0 .38.14l.23.07A3.4 3.4 0 0 0 5 28h19.09A3.05 3.05 0 0 0 27 25.89l2.85-9a2.85 2.85 0 0 0-.03-1.89z"
                    fill="#6a6a6a"
                />
            </g>
        </svg>
    );
};

export default FileManagerIcon;
